// Client error reporting is initialised here, in the client entry, gated on the Better Stack env
// vars — the single init path for the app (#180 dropped Sentry; observability is on Better Stack
// now). It lived here as the Sentry init under #162; the transport changed, the single-init-path
// rule did not. The client entry only ever runs in the browser, so the browser error reporter is
// always safe.
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { initErrorReporter } from "./errorReporter";
import { AppErrorBoundary } from "./AppErrorBoundary";

// The client entry is the one place that reads the VITE_-prefixed Better Stack env (inlined into
// the public bundle by Vite). An unconfigured build (no token, local dev) leaves the reporter a
// no-op, exactly as a missing Sentry DSN did before #180.
initErrorReporter({
  sourceToken: import.meta.env.VITE_BETTERSTACK_SOURCE_TOKEN,
  ingestUrl: import.meta.env.VITE_BETTERSTACK_INGEST_URL,
});

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  void navigator.serviceWorker.register("/service-worker.js");
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <AppErrorBoundary>
        <HydratedRouter />
      </AppErrorBoundary>
    </StrictMode>,
  );
});
